export default __webpack_public_path__ + "static/media/playstore.74457723.png";